import type { ViewMessage } from '@basgan/protocol';

/**
 * Oyuncu adına otomatik pas geçilmeli mi?
 *
 * Yalnızca gerçekten seçenek yokken. Oynanabilir tek bir kart bile varsa
 * karar oyuncunundur — pas geçmek bu oyunda stratejik bir hamle (yumuşak pas
 * olduğu için sıra tekrar gelir, yüksek kartı saklamak isteyebilir).
 *
 * Lider konumunda `legalMoves` içinde `pass` bulunmaz (turu açan pas geçemez),
 * ve elinde kart olan liderin her zaman oynayacak bir hamlesi vardır — bu
 * yüzden `canPass` koşulu liderliği de doğal olarak dışarıda bırakır.
 */
export function shouldAutoPass(view: ViewMessage): boolean {
  if (view.phase !== 'play') return false;
  if (view.turn !== view.you) return false;

  let canPlay = false;
  let canPass = false;
  for (const move of view.legalMoves) {
    if (move.type === 'play') canPlay = true;
    else canPass = true;
  }
  return !canPlay && canPass;
}
